export const areAllTruthy = (...args: any[]): boolean => {
  return args.every(value => value);
};

export const hasTruthyValue = (...args: any[]): boolean => {
  return args.some(value => value);
};
